module.exports = __webpack_public_path__ + "img/dealer-customer-login-hover.0480058f.png";